import { render, staticRenderFns } from "./Omalizumabe150Warning.vue?vue&type=template&id=a55abd06&"
import script from "./Omalizumabe150Warning.vue?vue&type=script&lang=js&"
export * from "./Omalizumabe150Warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports